import { useQuery } from '@hooks/reactQuery';

import { getPickedDates } from '@api/assetsRent';

import { IRentedOutAssetDates, TRangeDate } from '@interfaces/rent/assetRent';

import { ALREADY_RENTED_OUT_DATES } from '@constants/queryKeys';

interface IUseAlreadyRentedOutAssetDates {
	dates?: Array<TRangeDate>;
	isLoadingDates: boolean;
}

export function useQueryAlreadyRentedAssetsDatesPicked(
	assetId: string,
	requestId: string,
): IUseAlreadyRentedOutAssetDates {
	const {
		data,
		isInitialLoading,
	} = useQuery<IRentedOutAssetDates | undefined>({
		queryKey: [
			ALREADY_RENTED_OUT_DATES,
			assetId,
		],
		queryFn: () => {
			return assetId ? getPickedDates(assetId, requestId) : Promise.resolve({});
		},
		enabled: [!!assetId, !!requestId],
		refetchOnWindowFocus: false,
	});

	return {
		dates: data?.dates ? data.dates[0].ranges : undefined,
		isLoadingDates: isInitialLoading,
	};
}
